import Skeleton from 'react-loading-skeleton';

import 'react-loading-skeleton/dist/skeleton.css';

export const LoanSummaryLoader = () => {
  return <Skeleton containerTestId="loan-summary-loader" height={180} />;
};
